module.exports = __webpack_public_path__ + "static/img/4.7c725508.png";